'use strict';

/**
 * Auto loads next page of results when getting close to bottom of a scrollable area.
 * New results are appended to previous results and pagination is replaced with
 * pagination form the new page.
 * 
 * Here is an example setup. All options are required except as marked below.
 * 
	AutoLoadPages.setup({
		scrollableArea: '.table-wrap',		// Can be a string selector or jQuery object.
		resultsSelector: '.section--residences__results tbody',
		paginationSelector: '.pagination',
		nextSelector: '.next',
		loadWhenDistanceFromBottom: 200								// Optional
	});
 * 
 */

var $ = window.jQuery;
var Debouncer = require('./Debouncer.js');

function AutoLoadPages(opt) {
	opt.nextSelector = opt.nextSelector || '.next';
	opt.loadWhenDistanceFromBottom = opt.loadWhenDistanceFromBottom !== undefined ? opt.loadWhenDistanceFromBottom : 400;
	
	this.opt = opt;
	
	// If ajax happens we resetup to ensure if elements we reference change we get the most recent reference.
	$(document).on('ajaxComplete', this.setup.bind(this));
	
	// Initial setup.
	this.setup();
}
AutoLoadPages.prototype.destroy = function() {
	if (this.loadNextIfNeededDebouncer !== undefined) {
		// Setup to check if next page needs to loaded when window scrolled or window resized
		this.$scrollableArea.off('scroll', this.loadNextIfNeededDebouncer.run);
		$(window).off('load', this.loadNextIfNeededDebouncer.run);
		$(window).off('resize', this.loadNextIfNeededDebouncer.run);
	}
	
}
AutoLoadPages.prototype.setup = function() {
	var opt = this.opt;
	
	// If setup previously then undo setup and redo
	this.destroy();
	
	var $scrollableArea = typeof opt.scrollableArea === 'object' ? opt.scrollableArea : $(opt.scrollableArea);
	this.$scrollableArea = $scrollableArea;
	
	var $results = $(opt.resultsSelector);
	var $pagination = $(opt.paginationSelector);
	$pagination.addClass('isAutoLoadPage--setup');
	
	if (!$pagination || !$results) {
		// Nothing to setup
		return;
	}
	
	var currentlyLoading = false;
	
	var loadNextIfNeededDebouncer = new Debouncer(function(e) {
		var bottomOfResults =
				($results.get(0) === window ? 0 : $results.offset().top)
				+ $results.outerHeight();
		var bottomOfScrollableArea =
				$scrollableArea.scrollTop()
				+ $scrollableArea.outerHeight();
		
		if (bottomOfResults - bottomOfScrollableArea <= opt.loadWhenDistanceFromBottom) {
			// Near bottom of results, load next page.
			
			loadNextPage();
		}
	});
	this.loadNextIfNeededDebouncer = loadNextIfNeededDebouncer;
	
	var loadNextPage = function() {
		if (currentlyLoading || !$pagination) {
			// Already loading or  no next page to load.
			return false;
		}
		
		var $more = $pagination.find(opt.nextSelector);
		if (!$more) {
			return false;
		}
		
		var loadHref = $more.attr('href');
		if (typeof loadHref === 'undefined' || !loadHref.length) {
			return false;
		}
		
		// Stop multiple pages from loading at once
		currentlyLoading = true;

		// Seems new version of jQuery changes: /centpoint-web/insights.html?_=1466191391264&page=3
		//  to /centpoint-web/insights.html&page=3?_=1466191391265
		// 	so we remove the parameter to ensure we don't run into an issue
		loadHref = loadHref.replace(/&?_=[0-9]+/, '');
		loadHref = loadHref.replace(/\?&/, '?');
		
		// Load next page
		$.ajax({
			url: loadHref,
			cache: false
		}).done(function(html) {
			var $html = $(html);
			
			// Append new results
			$html.find(opt.resultsSelector).children().appendTo($results);
			
			// Update pagination
			var newPagination = $html.find(opt.paginationSelector);
			if (newPagination) {
				$pagination.replaceWith(newPagination);
				$pagination.addClass('isAutoLoadPage--setup');
				$pagination = newPagination;
			} else {
				// No more results
				$pagination.remove();
				$pagination = null;
			}
			
			// Set back so another page can load.
			currentlyLoading = false;
			
			// Check if even though we just loaded a page we need to load another one to fill the area.
			loadNextIfNeededDebouncer.runNow();
			
			// Tigger event
			$results.trigger('autoLoadedPages', {url: loadHref});
		});
	}
	
	// Setup to check if next page needs to loaded when window scrolled or window resized
	$scrollableArea.on('scroll', this.loadNextIfNeededDebouncer.run);
	$(window).on('load', this.loadNextIfNeededDebouncer.run);
	$(window).on('resize', this.loadNextIfNeededDebouncer.run);
};

module.exports = AutoLoadPages;

